import { render, staticRenderFns } from "./cinema-seat.vue?vue&type=template&id=94635760&scoped=true"
import script from "./cinema-seat.vue?vue&type=script&lang=js"
export * from "./cinema-seat.vue?vue&type=script&lang=js"
import style0 from "./cinema-seat.vue?vue&type=style&index=0&id=94635760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94635760",
  null
  
)

export default component.exports